import { render, staticRenderFns } from "./inbound.vue?vue&type=template&id=5ed2cd39&scoped=true"
import script from "./inbound.vue?vue&type=script&lang=js"
export * from "./inbound.vue?vue&type=script&lang=js"
import style0 from "./inbound.vue?vue&type=style&index=0&id=5ed2cd39&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed2cd39",
  null
  
)

export default component.exports